var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.buttonCss,attrs:{"disabled":_vm.isLoading},on:{"click":_vm.prepareToSend}},[_c('i',{staticClass:"fa fa-fw",class:_vm.iconCss}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78e5cca2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/stock/features/inventory/PrepareButton.vue
// module id = null
// module chunks = 